<mat-icon style="font-size:30px;" data-dismiss="modal" [mat-dialog-close]="false" class="material-icons close">close
</mat-icon>

<!-- Loading state while sending OTP -->
<div class="text-center" *ngIf="!initialSendComplete" style="padding: 40px 20px;">
    <h4 style="text-align: center; margin-bottom: 20px;">Sending Verification Code</h4>
    <p style="color: var(--button-bg-color); font-size: 16px;">
        Please wait while we send a verification code to {{full_phone}}...
    </p>
    <div style="margin-top: 20px;">
        <span style="color: var(--button-bg-color); font-weight: bold;">Sending...</span>
    </div>
</div>

<!-- Verification form (shown after OTP is sent) -->
<div class="text-center" *ngIf="initialSendComplete">
    <p *ngIf="dialogData.value!=='invalidOtp'" style="padding-bottom:5px;">
        <span *ngIf="otpChannel === 'WhatsApp'">Verification code sent via WhatsApp to {{full_phone}}</span>
        <span *ngIf="otpChannel === 'SMS'">Verification code sent via SMS to {{full_phone}}</span>
        <span *ngIf="!otpChannel">Verification code sent to {{full_phone}}</span>
    </p>
    <div>
        <h4 style="text-align: center;">Verify phone number </h4>
        <input class="form-control" style="text-align: center;  position: relative; margin: 0 auto;" [disabled]="true"
            [(ngModel)]="full_phone" name="full_phone" pInputText>
    </div>

    <p style="padding-top:20px;">Please enter the verification code</p>
    <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="config">
    </ng-otp-input>
    <p style="color:red;" *ngIf="verificationStatus == false"> Please enter valid verification code
    </p>

    <div style="padding-top: 5%;" class="text-center">
        <button style="background-color: var(--button-bg-color);" type="submit" class="btn btn-primary" id="button"
            [mat-dialog-close]="true" (click)="verifyOTP()"
            [disabled]="ngOtpInput.value == '' || !verificationStatus">Verify</button>
    </div>


    <p>Did not receive the verification code?<br>
        <span *ngIf="!resendDisabled && !resendingOtp">
            <b (click)="resendOtp()" style="cursor: pointer;"><a style="color: var(--button-bg-color);">Resend
                    verification code</a></b>
        </span>
        <span *ngIf="resendingOtp" style="color: var(--button-bg-color); font-weight: bold;">
            Sending...
        </span>
        <span *ngIf="resendDisabled && !resendingOtp" style="color: gray;">Resend verification
            code in {{resendCountdown}}s</span>
    </p>
    <p>Entered wrong phone? <br>
        <b [mat-dialog-close]="false"><a style="color: var(--button-bg-color);">Change Phone number</a></b>
    </p>
</div>